import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

const Wizard = ({ children, selected }) => {
  
  const childrens = children.filter(x => x)
  
  return (
    <div>
      <div>
        <ul className="flex flex-col xl:flex-row lg:flex-row space-x-0 xl:space-x-5 lg:space-x-5 space-y-2 xl:space-y-0 lg:space-y-0 py-2 xl:py-10 lg:py-5 justify-center">
          {childrens.filter(x => x).map((el, i) => {
              return (
                <li key={`${el.props.description}`} className={`${i <= selected ? 'text-success' : 'text-gray-300'} flex space-x-2`}>
                  {i <= selected ? <Icon.DotCheck /> : <Icon.DotUnCheck />}
                  <span>{el.props.description}</span>
                </li>
              )
          })}
        </ul>
      </div>
      {childrens[selected]}
    </div>
  )
}

Wizard.defaultProps = {
  selected: 0
}

Wizard.propTypes = {
  children: PropTypes.node.isRequired,
  selected: PropTypes.number.isRequired,
}

Wizard.Item = ({ description, children }) => {
  return (
    <div description={description}>
      {children}
    </div>
  )
}

Wizard.Item.propTypes = {
  description: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default Wizard